<template>
  <x-page title="全部分类" :loading="loading" no-safe-area>
    <div :class="_.page">
      <div :class="_.top">
        <div :class="_.search">
          <img :class="_.icon" src="./images/搜索.png" />
          <van-field
            v-model="value"
            placeholder="搜索"
            :clearable="true"
            @clear="search"
          />
        </div>
        <div :class="_.btn" @click="search">搜索</div>
      </div>

      <div v-if="categoryList.length != 0" :class="_.bottom">
        <div :class="_.left">
          <div
            v-for="(item, index) in categoryList"
            :key="item.categoryId"
            v-track="{
              name: '一级分类',
              id: 'clewf7jts000gvprl8nfa8zwz',
              newId: 'TuiJianType',
              extra: {
                first_commodity: item.categoryName,
                second_commodity: '',
                three_commodity: '',
                url: '',
                type_name: item.categoryName,
                type_id: item.categoryId,
              },
            }"
            :class="[
              _.item,
              categoryIndex === index && _.current,
              index === categoryIndex - 1 && _.prev,
              index === categoryIndex + 1 && _.next,
              index === '__placeholder__' && _.placeholder,
            ]"
            @click="
              handleFirstClick(index, item.frontCategoryListVOS[0].categoryId)
            "
          >
            <div :class="[_.name, _._ellipsis]">
              {{ item.categoryName }}
            </div>
          </div>
        </div>

        <div
          ref="scrollright"
          :key="rkindex"
          :class="_.right"
          @scroll="containerScroll"
        >
          <div
            v-for="(list, lindex) in categoryList"
            :key="lindex"
            class="containerBox"
            :class="_.first"
          >
            <div
              v-for="(second, secIndex) in list.frontCategoryListVOS"
              :key="secIndex"
              :class="_.second"
            >
              <div :class="_.title">
                {{ second.categoryName }}
              </div>
              <div :id="'sec' + second.categoryId" :class="_.list">
                <div
                  v-for="(third, thIndex) in second.frontCategoryListVOS"
                  :key="thIndex"
                  v-track="{
                    name: '三级分类',
                    id: 'clewf7jts000gvprl8nfa8zwz',
                    newId: 'TuiJianType',
                    extra: {
                      first_commodity: third.rootCategoryName,
                      second_commodity: second.categoryName,
                      three_commodity: third.categoryName,
                      url: '',
                      type_name: third.categoryName,
                      type_id: third.categoryId,
                    },
                  }"
                  :class="_.item"
                  @click="toAllClass(third.categoryId, third.categoryName)"
                >
                  <img :class="_.itemimg" :src="third.categoryPic" alt="" />
                  <span>{{ third.categoryName }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <x-empty v-else message="无搜索结果" />
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'
  import { Track } from '@/utils'

  import { apiCommodityFrontCategoryList } from '@/api'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '全部分类',
      })),
    ],

    data() {
      return {
        loading: true,
        value: '',
        categoryIndex: 0,
        categoryListAll: [],
        categoryList: [],
        scrollKey: true,
        rkindex: 0,
        scrollTop: 0,
        AppInfo: {},
        active: {
          index: 0,
          scrollH: 0,
        },
      }
    },

    computed: {
      primaryIdIndex() {
        let idx = 0
        // eslint-disable-next-line no-prototype-builtins
        if (this.$route.query.hasOwnProperty('primaryId')) {
          this.categoryList?.forEach((element, index) => {
            if (element.categoryId === this.$route.query.primaryId) {
              idx = index
            }
          })
        }
        return idx
      },
    },

    activated() {
      if (!this.loading) {
        const scrollArea = this.$refs.scrollright
        scrollArea.scrollTo({
          top: this.active.scrollH,
          behavior: 'auto',
        })
        setTimeout(() => {
          this.categoryIndex = this.active.index
        })
      }
    },

    async mounted() {
      this.loading = true
      await this.getCategoryList()
      this.categoryIndex = this.primaryIdIndex
      this.AppInfo = await dcb.getAppInfo()

      this.loading = false

      this.$nextTick(() => {
        if (
          // eslint-disable-next-line no-prototype-builtins
          this.$route.query.hasOwnProperty('secondaryId') &&
          this.categoryList.length !== 0
        ) {
          this.scrollToTag(this.$route.query.secondaryId)
        }
      })
    },

    methods: {
      handleFirstClick(index, pid) {
        this.categoryIndex = index
        //解决苹果滚动时点击菜单会丢失内容的问题
        // eslint-disable-next-line no-prototype-builtins
        if (this.AppInfo.hasOwnProperty('os_name')) {
          if (this.AppInfo.os_name === 'iOS') {
            this.rkindex++
            setTimeout(() => {
              this.scrollToTag(pid)
            })
          } else {
            this.scrollToTag(pid)
          }
        } else {
          this.scrollToTag(pid)
        }
      },

      //二级分类定位至显示区域
      scrollToTag(tagName) {
        const scrollArea = this.$refs.scrollright
        const element = scrollArea?.querySelector(`#sec${tagName}`)
        const firstElement = scrollArea?.querySelector(
          `#sec${this.categoryList[0]?.frontCategoryListVOS[0].categoryId}`,
        )
        this.scrollKey = false
        if (element) {
          scrollArea.scrollTo({
            top: element.offsetTop - firstElement.offsetTop,
            behavior: 'auto',
          })
        }
        setTimeout(() => {
          this.scrollKey = true
        }, 50)
      },

      //二级分类滚动事件:计算每个三级分类的可见高度
      containerScroll() {
        if (this.scrollKey) {
          const scrollArea = this.$refs.scrollright
          const areaST = scrollArea.scrollTop
          const areaOH = scrollArea.offsetHeight
          const element = scrollArea?.querySelectorAll('.containerBox')

          if (areaST > this.scrollTop) {
            for (let i = 0; i < element.length; i++) {
              this.computVisibleHeight(element, i, scrollArea, areaST, areaOH)
            }
          } else {
            for (let i = element.length - 1; i >= 0; i--) {
              this.computVisibleHeight(element, i, scrollArea, areaST, areaOH)
            }
          }

          this.scrollTop = areaST
        }
      },

      computVisibleHeight(element, i, scrollArea, areaST, areaOH) {
        const elementHeight = element[i].offsetHeight
        const elementOffset = element[i].offsetTop - scrollArea.offsetTop

        const isVisible =
          elementOffset >= areaST &&
          elementOffset + elementHeight <= areaST + areaOH

        let visibleHeight = 0
        if (isVisible) {
          visibleHeight = elementHeight
        } else if (elementOffset < areaST) {
          visibleHeight = elementHeight - (areaST - elementOffset)
        } else {
          visibleHeight =
            elementHeight - (elementOffset + elementHeight - areaST - areaOH)
        }

        if (areaOH > elementHeight) {
          if (visibleHeight >= elementHeight - 1) {
            //减一兼容一下华为p40及其它部分有少量计算偏差的手机
            this.categoryIndex = i
          }
        } else {
          if (visibleHeight >= areaOH * 0.8) {
            this.categoryIndex = i
          }
        }
      },

      async getCategoryList() {
        this.categoryListAll = await apiCommodityFrontCategoryList({
          adminSource: '',
          categoryName: '',
        })
        this.categoryListAll.forEach(root => {
          root.frontCategoryListVOS.forEach(item => {
            item.frontCategoryListVOS.forEach(item => {
              item.rootCategoryName = root.categoryName
            })
          })
        })
        this.categoryList = this.categoryListAll
      },

      toAllClass(id, name) {
        const scrollArea = this.$refs.scrollright
        navigateTo('MartClassifiedGoods', { id, name })
        this.active.index = this.categoryIndex
        this.active.scrollH = scrollArea.scrollTop
      },

      filterList(node, filter) {
        let res = false
        if (filter(node)) {
          res = true
        } else if (node.frontCategoryListVOS instanceof Array) {
          const _data = node.frontCategoryListVOS.filter(node => {
            return this.filterList(node, filter)
          })
          node.frontCategoryListVOS = _data
          if (node.frontCategoryListVOS.length > 0) {
            res = true
          }
        }
        return res
      },

      search() {
        this.rkindex++
        const list = JSON.parse(JSON.stringify(this.categoryListAll))
        if (this.value.length === 0) {
          this.categoryList = list
          this.handleFirstClick(0)
          return
        }
        this.categoryList = list.filter(node => {
          return this.filterList(node, node => {
            return node.categoryName.indexOf(this.value) >= 0
          })
        })
        this.handleFirstClick(0)
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #f5f5f5;
    height: 100%;

    :global {
      .van-field {
        padding: 0 !important;
        background-color: #f5f5f5 !important;
      }
    }

    .top {
      display: flex;
      align-items: center;
      height: 48px;
      padding: 6px 12px;
      box-sizing: border-box;
      background-color: #ffffff;
      .search {
        display: flex;
        width: 100%;
        height: 100%;
        padding: 0 12px;
        align-items: center;
        background-color: #f5f5f5;
        border-radius: 18px;
        .icon {
          width: 18px;
          height: 18px;
        }
      }
      .btn {
        flex-shrink: 0;
        width: 38px;
        font-size: 16px;
        text-align: right;
        font-weight: 500;
        color: #333333;
        margin-left: 12px;
      }
    }

    .bottom {
      height: calc(100% - 70px);
      display: flex;
      margin-top: 12px;
      overflow: hidden;

      .left {
        flex-shrink: 0;
        background-color: #f5f5f5;
        width: 88px;
        height: 100%;
        padding-bottom: 30px;
        box-sizing: border-box;
        overflow: auto;

        .item {
          position: relative;
          background-color: white;

          .name {
            padding: 12px 6px;
            text-align: center;
            font-size: 14px;
            background-color: #f5f5f5;
            color: #333333;
          }

          &.current {
            .name {
              font-weight: bold;
              // background-color: white;
              color: #ff111c;
            }

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 4px;
              height: 18px;
              background: #ff111c;
              border-radius: 0px 2px 2px 0px;
            }
          }

          &.prev {
            .name {
              // border-bottom-right-radius: 8px;
            }
          }

          &.next {
            .name {
              // border-top-right-radius: 8px;
            }
          }

          &.placeholder {
            pointer-events: none;
          }
        }
      }

      .right {
        flex-grow: 1;
        background-color: #f5f5f5;
        height: 100%;
        padding: 0 12px;
        overflow: auto;

        .first {
          // height: 100%;
          margin-bottom: 48px;
          // overflow: auto;

          &::-webkit-scrollbar {
            display: none;
          }

          .second {
            padding: 12px 12px 2px 12px;
            margin-bottom: 12px;
            background: #ffffff;
            border-radius: 8px;

            .title {
              font-size: 16px;
              font-weight: bold;
              color: #333333;
              padding-bottom: 8px;
              margin-left: 4px;
            }

            .list {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              justify-content: center;
              .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 12px;
                .itemimg {
                  width: 70px;
                  height: 67px;
                  border-radius: 8px;
                  background-color: #f7f8fa;
                }
                span {
                  margin-top: 6px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
